import { useEffect } from "react";
import { supabase } from "../services/supabase";
import { profileData } from "../config/profile";

function AuthCallback() {
  useEffect(() => {
    const handleCallback = async () => {
      try {
        const {
          data: { session },
        } = await supabase.auth.getSession();

        if (
          session?.user?.user_metadata?.user_name === profileData.githubName
        ) {
          window.location.href = "/admin";
        } else {
          await supabase.auth.signOut();
          // Changed redirect to home page with error query parameter
          window.location.href = "/?error=Not authorized";
        }
      } catch (error) {
        // console.error("Auth error:", error);
        // Changed redirect to home page with error query parameter
        window.location.href = "/?error=Authentication failed";
      }
    };

    handleCallback();
  }, []);

  return (
    <div className="flex justify-center items-center h-screen">
      <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-white"></div>
    </div>
  );
}

export default AuthCallback;
